import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Gift } from "lucide-react";

export function cortesiaErro(qtd, c) {
  const n = Number(c.qtd) || 0;
  if (n < 0 || n > qtd) return "As vagas cortesia não podem passar da quantidade de inscritos";
  if (n > 0 && !c.motivo.trim()) return "Informe o motivo da cortesia";
  return null;
}

function Dica({ qtd, n }) {
  if (!n) return <>Conta como aluno com R$ 0. Deixe 0 se não houver cortesia.</>;
  if (n >= qtd) return <b>Só cortesia: conta como aluno com R$ 0 e não gera pedido de NF.</b>;
  return <>{qtd - n} pagante{qtd - n > 1 ? "s" : ""} + {n} cortesia{n > 1 ? "s" : ""}. A NF sai só com o valor das vagas pagas.</>;
}

export function CortesiaFields({ qtd, value, onChange }) {
  const n = Number(value.qtd) || 0;
  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50/60 p-3 space-y-2" data-testid="cortesia-bloco">
      <div className="text-sm font-bold text-sky-900 flex items-center gap-1.5"><Gift className="w-4 h-4" /> Vagas cortesia</div>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <Label className="text-xs">Quantas?</Label>
          <Input type="number" min={0} max={qtd} value={value.qtd} onChange={(e) => onChange({ ...value, qtd: e.target.value })} data-testid="cortesia-qtd" />
        </div>
        {n > 0 && (
          <div className="col-span-2">
            <Label className="text-xs">Motivo da cortesia *</Label>
            <Input value={value.motivo} onChange={(e) => onChange({ ...value, motivo: e.target.value })} placeholder="Ex.: pacote 5 + 1, parceria, convidado" data-testid="cortesia-motivo" />
          </div>
        )}
      </div>
      <p className="text-[11px] text-sky-800" data-testid="cortesia-dica"><Dica qtd={qtd} n={n} /></p>
    </div>
  );
}
